<template lang="pug">
.news_ticker(
  :class="{ paused: isPaused }",
  @mouseenter="isPaused = true",
  @mouseleave="isPaused = false"
)
  .marquee-track
    .marquee-content(ref="marqueeContent")
      span.marquee-item(
        v-for="(marquee, index) in duplicatedMessageList",
        :key="index",
        :class="{ 'has-link': marquee.URL }",
        @click="marquee.URL && openUrl(marquee.URL)"
      ) {{ marquee.Title }}
</template>

<script>
export default {
  name: "NewsTicker",
  props: {
    messageList: Array,
  },
  data() {
    return {
      isPaused: false,
      SPEED_PX_PER_SEC: 64,
      MIN_DURATION: 20,
    };
  },
  computed: {
    duplicatedMessageList() {
      if (!this.messageList || this.messageList.length === 0) return [];
      return [...this.messageList, ...this.messageList];
    },
  },
  mounted() {
    setTimeout(() => {
      this.updateAnimationDuration();
    }, 0);
    window.addEventListener("resize", this.updateAnimationDuration);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateAnimationDuration);
  },
  methods: {
    updateAnimationDuration() {
      this.$nextTick(() => {
        const content = this.$refs.marqueeContent;
        if (content) {
          const width = content.scrollWidth;
          const duration = Math.max(width / this.SPEED_PX_PER_SEC, this.MIN_DURATION);
          content.style.animationDuration = `${duration}s`;
        }
      });
    },
    openUrl(url) {
      if (url && url != "") {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/news_ticker";
</style>
